<template>
    <AppSelect
        :id="componentId"
        :items="filteredUsers"
        itemKeyField="uuid"
        :itemMinHeight="39"
        :disabled="disabled"
        @select="onSelect"
        @open="onSelectOpen">

        <div>
            <AppSelectUserBatteryItem
                v-for="(uuid, idx) in assignedUserUuids.slice(0, displayedQty)"
                @remove="onSelect"
                :key="uuid"
                :user="getAssignedUser(uuid)"
                :disabled="disabled"
                :style="{
                    'z-index': displayedQty - idx + 1,
                    'margin-left': `${idx === 0 ? '0' : '-12'}px`
                }"/>

            <div v-if="multiple && assignedUserUuids.length > displayedQty" class="exceed-quantity">
                <div v-tooltip.top="`${assignedUserUuids.length - displayedQty} more people`" class="text-center">
                    <div class="exceed-quantity-number">
                        {{ assignedUserUuids.length - displayedQty }}
                    </div>
                </div>
            </div>

            <div v-if="!disabled && (multiple || (!multiple && uuids.length === 0))" class="add-btn"
                 :style="{ 'margin-left': `${assignedUserUuids.length === 0 ? '0' : '-12'}px` }">
                <span class="emptyIconCircle text-center">
                    <i class="fal fa-user"></i>
                </span>
                <div class="add-btn-plus">
                    <i class="fa fa-plus"></i>
                </div>
            </div>
        </div>

        <template v-slot:header>
            <input v-model="query"
                   ref="search"
                   type="search"
                   placeholder="Search"
                   class="form-control form-control-sm">
        </template>
        <template #item="{ item }">
            <AppSelectUserRow
                :user="item"
                :selected="assignedUserUuids.includes(item.uuid)"
                :disabled="disabled"/>
        </template>
    </AppSelect>
</template>

<script>
import {mapGetters} from 'vuex'
import AppSelect from '../AppSelect'
import AppSelectUserRow from './AppSelectUserRow'
import AppSelectUserBatteryItem from './AppSelectUserBatteryItem'
import {getUserFullName} from '@/utils/user'
import {UNASSIGNED} from '@/types/data'

export default {
    name: 'AppSelectUser',
    props: {
        componentId: {
            type: String
        },
        uuids: {
            required: true,
            type: Array
        },
        multiple: {
            type: Boolean,
            default: false
        },
        withUnassign: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        displayedQty: {
            type: Number,
            default: 4
        }
    },
    components: {AppSelectUserBatteryItem, AppSelectUserRow, AppSelect},
    data() {
        return {
            query: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMembers',
            'getActiveMembers',
            'getMemberByUuid'
        ]),

        users() {
            if (this.withUnassign) {
                return this.getActiveMembers.concat({uuid: UNASSIGNED, firstName: 'Unassign', lastName: ''})
            }
            return this.getActiveMembers
        },

        mappedUsers() {
            return this.users.map(item => ({...item, fullName: getUserFullName(item)}))
        },

        filteredUsers() {
            return this.mappedUsers.filter(user => user.fullName.toLowerCase().includes(this.query.toLowerCase()))
        },

        assignedUserUuids() {
            return _.uniq(this.uuids.filter(uuid => this.getMemberByUuid(uuid)))
        }
    },
    methods: {
        async onSelectOpen() {
            await this.$nextTick()
            this.$refs.search.focus()
        },

        onSelect(user) {
            if (this.disabled) {
                this.$snackbar.show({text: 'Disabled for changes'})
                return
            }
            this.$emit('select', user)
        },

        getAssignedUser(uuid) {
            return this.getMembers.find(user => user.uuid === uuid) || {firstName: 'Unknown', lastName: 'User'}
        }
    }
}
</script>

<style lang="scss" scoped>
$border: 1px solid white;

.add-btn {
    position: relative;
    display: inline-block;

    &:hover {
        cursor: pointer;

        .emptyIconCircle {
            color: $color-success;
            border-color: $color-success;
        }

        .add-btn-plus {
            background: $color-success;
        }
    }

    .add-btn-plus {
        position: absolute;
        display: inline-block;
        vertical-align: middle;
        background: $color-grey-light;
        color: white;
        border: $border;
        border-radius: 100%;
        bottom: 0;
        right: 0;
        width: 18px;
        height: 18px;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
    }
}

.exceed-quantity {
    position: relative;
    display: inline-block;
    height: 31px;
    width: 31px;
    line-height: 29px;
    margin-left: -12px;
    background: white;
    border: $border;
    border-radius: 100%;
    z-index: 1;
    text-align: center;
    vertical-align: middle;
    color: #cecece;
    font-size: 16px;
    transition: all .3s;

    .exceed-quantity-number {
        background: $color-grey-light;
        border-radius: 100%;
        color: white;
        font-size: 14px;
    }
}
</style>
